import { ref, computed } from 'vue';
import { useThrottleFn, useMounted } from '@vueuse/core';

export default function useScroller(props) {
  const carouselWrapperRef = ref();
  const carouselRef = ref();
  const left = ref(0);

  const isMounted = useMounted();
  const align = computed(() => isMounted.value && (carouselRef.value?.scrollWidth > carouselRef.value?.clientWidth ? 'start' : 'center'));
  const isPrevVisible = computed(() => isMounted.value && props.hasChevrons && left.value > 0);
  const scrollLeftLimitRef = computed(() => carouselRef.value?.scrollWidth - carouselWrapperRef.value?.clientWidth);
  const isForwardVisible = computed(() => isMounted.value && props.hasChevrons && left.value < scrollLeftLimitRef.value);

  const getShift = (shift = props.shift) => Math.round((carouselWrapperRef.value?.clientWidth || 0) * shift);
  const getLeft = (direction) => {
    const shift = getShift();
    let newLeft = left.value + (shift * direction);
    const moreThanLimit = direction > 0 && newLeft > scrollLeftLimitRef.value;
    const lessThanZero = direction < 0 && newLeft < 0;
    if (moreThanLimit) {
      newLeft = scrollLeftLimitRef.value;
    } else if (lessThanZero) {
      newLeft = 0;
    }

    return newLeft;
  };

  const scrollEl = (x) => {
    carouselRef.value?.scroll({
      top: 0,
      left: x,
      behavior: 'smooth',
    });
  };

  const onScroll = useThrottleFn(() => {
    left.value = Math.ceil(carouselRef.value.scrollLeft);
  }, 300, true);

  const scroll = (direction) => {
    left.value = getLeft(direction);
    scrollEl(left.value);
  };

  const forward = () => {
    scroll(1);
  };

  const backward = () => {
    scroll(-1);
  };

  return {
    carouselWrapperRef,
    carouselRef,
    onScroll,
    forward,
    backward,
    isForwardVisible,
    isPrevVisible,
    left,
    align,
  };
}
